export const GET_LOGIN_REQUEST='GET_LOGIN_REQUEST'
export const GET_LOGIN_SUCCESS='GET_LOGIN_SUCCESS'
export const GET_LOGIN_FAILURE='GET_LOGIN_FAILURE'

export const POST_LOGIN_REQUEST='POST_LOGIN_REQUEST'
export const POST_LOGIN_SUCCESS='POST_LOGIN_SUCCESS'
export const POST_LOGIN_FAILURE='POST_LOGIN_FAILURE'
